import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import './QueueCreate.css';
import success from "../images/correct.svg";

const QueueCreate = () => {
  const { getText } = useLanguage();
  const [progress, setProgress] = useState(0);
  const [queueData, setQueueData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();

  const getQueueData = () => {
    if (location.state?.queueData) {
      return location.state.queueData;
    }
  };
  
  const currentQueueData = queueData || getQueueData();
  const queueCode = currentQueueData?.code || '000';
  const prefix = currentQueueData?.prefix || '';
  
  useEffect(() => {
    const duration = 6000;
    const intervalTime = 100;
    const step = (intervalTime / duration) * 100;
    const timer = setInterval(() => {
      setProgress((prev) => (prev >= 100 ? 100 : prev + step));
    }, intervalTime);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (progress >= 100) {
      const timeout = setTimeout(() => navigate('/services'), 500);
      return () => clearTimeout(timeout);
    }
  }, [progress, navigate]);

  return (
      <div className="status-page">
        <main className="status-content">
          {/* Корти асосӣ мувофиқи Figma Frame 1321315870 */}
          <div className="status-card">

            <div className="card-inner">
              {/* Иконаи муваффақият - Frame 4352 */}
              <div className="success-icon-container">
                <div className="qab-correct-icon">
                  <img src={success} alt="success" />
                </div>
              </div>

              <h2 className="queue-label">{getText('Ваш номер в очереди', 'Рақами навбати шумо')}</h2>

              {/* Рақами навбат - Frame 1321315869 */}
              <div className="queue-id-container">
                <div className="queue-id">{queueCode}</div>
              </div>
              
              <p className="instruction-text">
                {getText('Пожалуйста, ожидайте ваш номер', 'Лутфан, интизорори рақами худ')}
                <br />
                {getText('на главном табло в зале', 'дар монитори толор бошед')}.
              </p>
            </div>
          </div>
        </main>

        {/* Прогресс бар дар поён - Rectangle 944 */}
        <div className="progress-footer">
          <div className="progress-bar" style={{ width: `${progress}%` }}></div>
        </div>
      </div>
  );
};

export default QueueCreate;